import { getTrans } from '@/js/helpers/getTrans';

export const web3AuthErrorMessages = {
    ALREADY_PROCESSING: getTrans('auth.web3AuthErrorMessage1', 'To continue, open the Metamask extension and complete required actions.'),
    SIGNATURE_CLOSED_BY_USER: getTrans('auth.web3AuthErrorMessage2', 'Wallet connection rejected. Please sign the message in your wallet to continue.'),
    CONNECTION_CLOSED_BY_USER: getTrans('auth.web3AuthErrorMessage3', 'Wallet connection rejected. Please connect a wallet to continue.'),
};
